import {
  setThemeProperty,
  getThemeProperty,
} from "../../theme/defaultThemeOperators";
export const getSadColor = getThemeProperty("sadColor");
export const getNeutralColor = getThemeProperty("neutralColor");
export const getHappyColor = getThemeProperty("happyColor");
export const setSadColor = setThemeProperty("sadColor");
export const setNeutralColor = setThemeProperty("neutralColor");
export const setHappyColor = setThemeProperty("happyColor");
